import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function AnnouncementBar() {
  return <div className="w-full bg-forest-700 text-paper" data-id="element-14" data-mp="oka9wu4c0xgv">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-center px-5 py-2.5 text-center sm:px-6 lg:px-8" data-id="element-15" data-mp="omwrlmkxstct">
        <span className="inline-flex items-center gap-2 text-small" data-id="element-16" data-mp="ev0ep5e6yyoj">
          <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-gold-light" strokeWidth={1.75} data-id="element-17" data-mp="euqqnncpj1lh" />
          No win, no fee · Nothing to pay while your claim is running
        </span>
      </div>
    </div>;
}